const routes = {
  getInvoiceList: 'vehicleBookings/invoices',
  getInvoiceDetails: 'vehicleBookings/invoice/details',
  getInvoicePreview: 'vehicleBookings/invoice/preview',
  createVehiclePayment: 'vehicleBookings/payment/add',
  getVehiclePaymentHistory: 'vehicleBookings/payment/history',
  addPaymentSlip: 'vehicleBookings/payment/addSlip',
  getPaymentList: 'vehicleBookings/payments',
  getPaymentDetails: 'vehicleBookings/payment/detailed',
  getPaymentPreview: 'vehicleBookings/payment/preview',
};

export default routes